// Course Report Utilities
export const getHeaderClass = (header) => {
	switch (header) {
		case 'AP':
			return 'gpaBlue'
		case 'CC':
			return 'gpaGreen'
		case 'EA':
			return 'gpaOrange'
		case 'HR':
			return 'gpaYellow'
		case 'RG':
			return 'gpaLightRed'
		case 'OT':
			return 'gpaRed'
		case 'Overall':
		case 'Ovr':
			return 'totalCell'
		default:
			return ''
	}
}

export const getColorClass = (value, type) => {
	const val = parseFloat(value)
	if (isNaN(val)) return ''

	switch (type) {
		case 'gpa4':
			if (val >= 3.89) return 'gpaBlue'
			if (val >= 3.69) return 'gpaGreen'
			if (val >= 3.29) return 'gpaYellow'
			if (val >= 2.99) return 'gpaOrange'
			if (val >= 2.29) return 'gpaLightRed'
			return 'gpaRed'

		case 'gpa10':
			if (val >= 9.0) return 'gpaBlue'
			if (val >= 8.0) return 'gpaGreen'
			if (val >= 6.5) return 'gpaYellow'
			if (val >= 5.0) return 'gpaOrange'
			if (val >= 3.5) return 'gpaLightRed'
			return 'gpaRed'

		case 'percent':
			if (val >= 90) return 'gpaBlue'
			if (val >= 80) return 'gpaGreen'
			if (val >= 65) return 'gpaYellow'
			if (val >= 50) return 'gpaOrange'
			if (val >= 30) return 'gpaLightRed'
			return 'gpaRed'

		case 'gpa5':
			if (val >= 4.5) return 'gpaBlue'
			if (val >= 4.0) return 'gpaGreen'
			if (val >= 3.5) return 'gpaYellow'
			if (val >= 3.0) return 'gpaOrange'
			if (val >= 2.0) return 'gpaLightRed'
			return 'gpaRed'

		default:
			return ''
	}
}

export const LEVEL_ORDER = ['AP', 'CC', 'HR', 'EA', 'RG', 'OT']

export const sortLevels = (levels) => {
	return LEVEL_ORDER.filter((lvl) => levels.includes(lvl))
}
